import { Box, Collapse, Stack, Typography }                  from '@mui/material'
import TableRowsIcon from '@mui/icons-material/TableRows';
import RenderContextProvider    from 'contexts/RenderContext'
import Elevate                  from 'components/common/Elevate'
import ListTable, { ListProps } from 'components/view/ListTable'
import React from 'react'
import { ExpandMoreButton } from 'components/common/ExpandMoreButton'
import { useTranslator } from 'hooks/translator';
import { F }                        from 'helpers/formatter';

const ListSection = (listProps: ListProps) => {
  const [expanded, setExpanded] = React.useState(true)
  const { schema, section }     = listProps

  const { translator } = useTranslator()
  const label = translator.translate(
      `${schema.translationBaseKey}.sections.${section.key}`,
      { user: true, fallback: section.label, format: F.toTitleCase }
    )

  return (
    <RenderContextProvider parent="list" props={{ listKey: listProps.section.key, detailKey: listProps.section.detail }}>
      <Elevate sx={{ 
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: "hidden",
        display: "flex", 
        height: "fit-content", 
      }}>
        <Box sx={{ overflow: "hidden", maxHeight: '100%', maxWidth: '100%', display: 'flex', flexFlow: 'column' }}>
          <Stack alignItems='center' justifyContent="space-between" direction='row' bgcolor='#f5f5f5' borderBottom='1px solid rgba(224, 224, 224, 1)' >
            <Stack alignItems='start' alignContent='center' direction='row' spacing={1} marginLeft={1}>
              <TableRowsIcon color='disabled'/>
              <Typography marginLeft='16px' fontWeight={500}>{label}</Typography>
            </Stack>
            <ExpandMoreButton expanded={expanded} setExpanded={setExpanded}/>
          </Stack>
          <Collapse in={expanded}>
            <Box id='list-container' sx={{display: "flex", flexGrow: 1, overflow: "auto"}}>
              <ListTable {...listProps}/>
            </Box>
          </Collapse>
        </Box>
      </Elevate>
    </RenderContextProvider>
  )
}

export default ListSection
